import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AiSemanticSearchRequest {
  query_text: string;
  top_k?: number;
  prefer_recent?: boolean;
}

export interface AiSemanticSearchResult {
  note_id?: string;
  id?: string;
  title?: string;
  snippet?: string;
  distance?: number;
  score?: number;
  [key: string]: unknown;
}

export interface AiSemanticSearchData {
  results?: AiSemanticSearchResult[];
  [key: string]: unknown;
}

export interface AiSemanticSearchResponse {
  status?: string;
  data?: AiSemanticSearchData;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class AiSemanticSearchTestService {
  constructor(private readonly http: HttpClient) {}

  // Test-only endpoint call for semantic note search.
  searchNotes(payload: AiSemanticSearchRequest): Observable<AiSemanticSearchResponse> {
    return this.http.post<AiSemanticSearchResponse>('/api/ai/search-notes', payload);
  }
}
